import React from 'react';
import { Page } from 'components';
import { CountryTaxRateProvider } from './CountryTaxRateContext';
import CountryTaxRate from './CountryTaxRate';


let Index = () => {
    return (
        <CountryTaxRateProvider>
            <Page title="Country tax rate">
                <CountryTaxRate />
            </Page>
        </CountryTaxRateProvider>
    );
}

export default Index;